export type RenderTimelineListener = (timeMs: number) => void;

type RendererWindow = Window & {
  __NEUROBAKER_RENDERER__?: boolean;
  __setRenderTimelineMs?: RenderTimelineListener;
};

const listeners = new Set<RenderTimelineListener>();
const dispatchRenderTimeline = (timeMs: number) => {
  for (const listener of listeners) listener(timeMs);
};

function getRendererWindow(): RendererWindow {
  return window as RendererWindow;
}

export function isRenderTimelineControlled(): boolean {
  return getRendererWindow().__NEUROBAKER_RENDERER__ === true;
}

export function subscribeRenderTimeline(listener: RenderTimelineListener): () => void {
  const rendererWindow = getRendererWindow();
  listeners.add(listener);
  rendererWindow.__setRenderTimelineMs = dispatchRenderTimeline;

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && rendererWindow.__setRenderTimelineMs === dispatchRenderTimeline) {
      delete rendererWindow.__setRenderTimelineMs;
    }
  };
}
